<template>
  <div class="filters-selected">
    <div v-if="false" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.CompanyPlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="company in selectedCompanies" :key="company.Id" type="is-primary is-small is-icon"
                    :value="company.Id" @click="onSelectedCompanyRemove(parseInt(company.Id))">
            <span>{{ company.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedCommitments.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.ProjectPerformancePlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="commitment in selectedCommitments" :key="commitment.Id" type="is-primary is-small is-icon"
                    :value="commitment.Id" @click="onSelectedCommitmentRemove(parseInt(commitment.Id))">
            <span>{{ commitment.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedChannelMetadataTypes.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.ChannelMetadataPlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="channelMetadataType in selectedChannelMetadataTypes" :key="channelMetadataType.Id"
                    type="is-primary is-small is-icon" :value="channelMetadataType.Id"
                    @click="onSelectedChannelMetadataTypeRemove(parseInt(channelMetadataType.Id))">
            <span>{{ channelMetadataType.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="usedSelectedFoundMetadataTypesIds.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.FoundMetadataPlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="channelMetadataType in selectedFoundMetadataTypes" :key="channelMetadataType.Id"
                    type="is-primary is-small is-icon" :value="channelMetadataType.Id"
                    @click="onSelectedFoundMetadataTypeRemove(parseInt(channelMetadataType.Id))">
            <span>{{ channelMetadataType.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedChannels.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.ChannelPlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="channel in selectedChannels" :key="channel.Id" type="is-primary is-small is-icon"
                    :value="channel.Id" @click="onSelectedChannelRemove(parseInt(channel.Id))">
            <span>{{ channel.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedAssets.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.AssetsFilterPlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="asset in selectedAssets" :key="asset.AssetId" type="is-primary is-small is-icon"
                    :value="asset.AssetId" @click="onSelectedAssetRemove(asset.AssetId)">
            <span>{{ asset.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedAdTitlesFiltered.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.AdTitleFilterPlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="adTitle in selectedAdTitlesFiltered" :key="getAdTitleId(adTitle)"
                    type="is-primary is-small is-icon" :value="getAdTitleId(adTitle)"
                    @click="onSelectedAdTitleRemove(getAdTitleId(adTitle))">
            <span>{{ stripTags(adTitle.AdTitle) }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedAdGroups.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.AdGroupsFilterPlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="adGroup in selectedAdGroups" :key="adGroup.Id" type="is-primary is-small is-icon"
                    :value="adGroup.Id" @click="onSelectedAdGroupRemove(adGroup.Id)">
            <span>{{ adGroup.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedLeadStatuses.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.ClientStageOnCreate") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="leadStatus in selectedLeadStatuses" :key="leadStatus.Id" type="is-primary is-small is-icon"
                    :value="leadStatus.Id" @click="onSelectedLeadStatusRemove(leadStatus.Id)">
            <span>{{ leadStatus.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="usedSelectedCallStatusesIds.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.LeadType") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="callStatus in selectedCallStatuses" :key="+callStatus.Id" type="is-primary is-small is-icon"
                    :value="+callStatus.Id" @click="onSelectedCallStatusRemove(+callStatus.Id)">
            <span>{{ callStatus.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedTagsFiltered.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.Tag") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="tag in selectedTagsFiltered" :key="tag.Title" type="is-primary is-small is-icon"
                    :value="tag.Title" @click="onSelectedTagRemove(tag.Id)">
            <span>{{ tag.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedSaleStatuses.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.SaleStatus") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="saleStatus in selectedSaleStatuses" :key="+saleStatus.Id" type="is-primary is-small is-icon"
                    :value="+saleStatus.Id" @click="onSelectedSaleStatusRemove(+saleStatus.Id)">
            <span>{{ saleStatus.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedAdditionalStatuses.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.AdditionalStatus") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="status in selectedAdditionalStatuses" :key="+status.Value" type="is-primary is-small is-icon"
                    :value="+status.Value" @click="onSelectedAdditionalStatusRemove(+status.Value)">
            <span>{{ status.Text }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedAssignees.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.Assignee") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="assignee in selectedAssignees" :key="assignee.SalesmanID" type="is-primary is-small is-icon"
                    :value="assignee.SalesmanID" @click="onSelectedAssigneeRemove(assignee.SalesmanID)">
            <span>{{ assignee.SalesmanName }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <b-button type="is-warning" size="is-small" class="reset-filters-btn" :label="$t('ResetFilters')"
              v-if="hasFilters"
              @click="resetFilters()" />
  </div>
</template>

<script lang="ts">
import moment from "moment";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AdTitlesByLeads, Assignee, ChannelMultiselectItem, MultiselectItem, SelectListItem } from "@/models/MultiselectItem";
import CampaignService from "@/services/CampaignService";
import IconBase from "../IconBase.vue";
import IconTimesSmall from "../icons/IconTimesSmall.vue";
import { ClientProject } from "@/models/ClientProject";
import { LeadsPageKind } from "@/models/LeadsPageKind";
import { AvailableChannelMetadataTypesMode } from "@/models/campaigns/ChannelType";
import { LeadsPageViewModel } from "@/models/leads/Lead";
import { LeadPriceType } from "@/models/leads/LeadPriceType";
import { LeadStatus } from "@/models/leads/LeadStatus";
import HelperService from "@/services/HelperService";
import LeadService from "@/services/LeadService";

const namespace = "leadsModule";

@Component({
  components: {
    IconBase,
    IconTimesSmall,
  },
})
export default class LeadsFiltersSelected extends Vue {
  @Prop({ required: true }) readonly pageKind!: LeadsPageKind;

  @Getter("leadsPageData", { namespace }) leadsPageData!: LeadsPageViewModel;
  @Getter("additionalStatuses", { namespace }) additionalStatuses!: SelectListItem[];
  @Getter("adGroups", { namespace }) adGroups!: MultiselectItem[];
  @Getter("adTitles", { namespace }) adTitles!: AdTitlesByLeads[];
  @Getter("assets", { namespace }) assets!: ClientProject[];
  @Getter("assignees", { namespace }) assignees!: Assignee[];
  @Getter("channels", { namespace }) channels!: ChannelMultiselectItem[];
  @Getter("companies", { namespace }) companies!: MultiselectItem[];
  @Getter("commitments", { namespace }) commitments!: MultiselectItem[];
  @Getter("datePeriod", { namespace }) datePeriod!: Date[];
  @Getter("clientsDatePeriod", { namespace }) clientsDatePeriod!: Date[];
  @Getter("clientsSelectedAdditionalStatusesIds", { namespace }) clientsSelectedAdditionalStatusesIds!: number[];
  @Getter("clientsSelectedAdGroupsIds", { namespace }) clientsSelectedAdGroupsIds!: string[];
  @Getter("clientsSelectedAdTitles", { namespace }) clientsSelectedAdTitles!: string[];
  @Getter("clientsSelectedAssetsIds", { namespace }) clientsSelectedAssetsIds!: string[];
  @Getter("clientsSelectedAssigneesIds", { namespace }) clientsSelectedAssigneesIds!: number[];
  @Getter("clientsSelectedCallStatusesIds", { namespace }) clientsSelectedCallStatusesIds!: number[];
  @Getter("clientsSelectedChannelMetadataTypesIds", { namespace }) clientsSelectedChannelMetadataTypesIds!: number[];
  @Getter("clientsSelectedChannelsIds", { namespace }) clientsSelectedChannelsIds!: number[];
  @Getter("clientsSelectedCompaniesIds", { namespace }) clientsSelectedCompaniesIds!: number[];
  @Getter("clientsSelectedCommitmentsIds", { namespace }) clientsSelectedCommitmentsIds!: number[];
  @Getter("clientsSelectedFoundMetadataTypesIds", { namespace }) clientsSelectedFoundMetadataTypesIds!: number[];
  @Getter("clientsSelectedLeadStatusesIds", { namespace }) clientsSelectedLeadStatusesIds!: LeadStatus[];
  @Getter("clientsSelectedPriceType", { namespace }) clientsSelectedPriceType!: string;
  @Getter("clientsSelectedSaleStatusesIds", { namespace }) clientsSelectedSaleStatusesIds!: LeadStatus[];
  @Getter("clientsSelectedTags", { namespace }) clientsSelectedTags!: string[];
  @Getter("selectedAdditionalStatusesIds", { namespace }) selectedAdditionalStatusesIds!: number[];
  @Getter("selectedAdGroupsIds", { namespace }) selectedAdGroupsIds!: string[];
  @Getter("selectedAdTitles", { namespace }) selectedAdTitles!: string[];
  @Getter("selectedAssetsIds", { namespace }) selectedAssetsIds!: string[];
  @Getter("selectedAssigneesIds", { namespace }) selectedAssigneesIds!: number[];
  @Getter("selectedCallStatusesIds", { namespace }) selectedCallStatusesIds!: number[];
  @Getter("selectedChannelMetadataTypesIds", { namespace }) selectedChannelMetadataTypesIds!: number[];
  @Getter("selectedChannelsIds", { namespace }) selectedChannelsIds!: number[];
  @Getter("selectedCompaniesIds", { namespace }) selectedCompaniesIds!: number[];
  @Getter("selectedCommitmentsIds", { namespace }) selectedCommitmentsIds!: number[];
  @Getter("selectedFoundMetadataTypesIds", { namespace }) selectedFoundMetadataTypesIds!: number[];
  @Getter("selectedLeadStatusesIds", { namespace }) selectedLeadStatusesIds!: number[];
  @Getter("selectedPriceType", { namespace }) selectedPriceType!: string;
  @Getter("selectedSaleStatusesIds", { namespace }) selectedSaleStatusesIds!: LeadStatus[];
  @Getter("selectedTags", { namespace }) selectedTags!: string[];
  @Getter("tags", { namespace }) tags!: MultiselectItem[];
  @Action("setClientsSelectedAdditionalStatusesIds", { namespace }) setClientsSelectedAdditionalStatusesIds!: (selectedAdditionalStatusesIds: number[]) => void;
  @Action("setClientsSelectedAdGroupsIds", { namespace }) setClientsSelectedAdGroupsIds!: (selectedAdGroupsIds: string[]) => void;
  @Action("setClientsSelectedAdTitles", { namespace }) setClientsSelectedAdTitles!: (selectedAdTitles: string[]) => void;
  @Action("setClientsSelectedAssetsIds", { namespace }) setClientsSelectedAssetsIds!: (selectedAssetsIds: string[]) => void;
  @Action("setClientsSelectedAssigneesIds", { namespace }) setClientsSelectedAssigneesIds!: (selectedAssigneesIds: number[]) => void;
  @Action("setClientsSelectedCallStatusesIds", { namespace }) setClientsSelectedCallStatusesIds!: (selectedCallStatusesIds: number[]) => void;
  @Action("setClientsSelectedChannelMetadataTypesIds", { namespace }) setClientsSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setClientsSelectedChannelsIds", { namespace }) setClientsSelectedChannelsIds!: (selectedChannelsIds: number[]) => void;
  @Action("setClientsSelectedCompaniesIds", { namespace }) setClientsSelectedCompaniesIds!: (selectedCompaniesIds: number[]) => void;
  @Action("setClientsSelectedCommitmentsIds", { namespace }) setClientsSelectedCommitmentsIds!: (selectedCommitmentsIds: number[]) => void;
  @Action("setClientsSelectedFoundMetadataTypesIds", { namespace }) setClientsSelectedFoundMetadataTypesIds!: (selectedFoundMetadataTypesIds: number[]) => void;
  @Action("setClientsSelectedLeadStatusesIds", { namespace }) setClientsSelectedLeadStatusesIds!: (selectedLeadStatusesIds: number[]) => void;
  @Action("setClientsSelectedSaleStatusesIds", { namespace }) setClientsSelectedSaleStatusesIds!: (selectedSaleStatusesIds: LeadStatus[]) => void;
  @Action("setClientsSelectedTags", { namespace }) setClientsSelectedTags!: (selectedTags: string[]) => void;
  @Action("setSelectedAdditionalStatusesIds", { namespace }) setSelectedAdditionalStatusesIds!: (selectedAdditionalStatusesIds: number[]) => void;
  @Action("setSelectedAdGroupsIds", { namespace }) setSelectedAdGroupsIds!: (selectedAdGroupsIds: string[]) => void;
  @Action("setSelectedAdTitles", { namespace }) setSelectedAdTitles!: (selectedAdTitles: string[]) => void;
  @Action("setSelectedAssetsIds", { namespace }) setSelectedAssetsIds!: (selectedAssetsIds: string[]) => void;
  @Action("setSelectedAssigneesIds", { namespace }) setSelectedAssigneesIds!: (selectedAssigneesIds: number[]) => void;
  @Action("setSelectedCallStatusesIds", { namespace }) setSelectedCallStatusesIds!: (selectedCallStatusesIds: number[]) => void;
  @Action("setSelectedChannelMetadataTypesIds", { namespace }) setSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setSelectedChannelsIds", { namespace }) setSelectedChannelsIds!: (selectedChannelsIds: number[]) => void;
  @Action("setSelectedCompaniesIds", { namespace }) setSelectedCompaniesIds!: (selectedCompaniesIds: number[]) => void;
  @Action("setSelectedCommitmentsIds", { namespace }) setSelectedCommitmentsIds!: (selectedCommitmentsIds: number[]) => void;
  @Action("setSelectedFoundMetadataTypesIds", { namespace }) setSelectedFoundMetadataTypesIds!: (selectedFoundMetadataTypesIds: number[]) => void;
  @Action("setSelectedLeadStatusesIds", { namespace }) setSelectedLeadStatusesIds!: (selectedLeadStatusesIds: number[]) => void;
  @Action("setSelectedSaleStatusesIds", { namespace }) setSelectedSaleStatusesIds!: (selectedSaleStatusesIds: LeadStatus[]) => void;
  @Action("setSelectedTags", { namespace }) setSelectedTags!: (selectedTags: string[]) => void;

  get hasFilters(): boolean {
    return this.selectedCompanies.length > 0
        || this.selectedCommitments.length > 0
        || this.selectedChannelMetadataTypes.length > 0
        || this.usedSelectedFoundMetadataTypesIds.length > 0
        || this.selectedChannels.length > 0
        || this.selectedAssets.length > 0
        || this.selectedAdTitlesFiltered.length > 0
        || this.selectedAdGroups.length > 0
        || this.selectedLeadStatuses.length > 0
        || this.usedSelectedCallStatusesIds.length > 0
        || this.selectedTagsFiltered.length > 0
        || this.selectedSaleStatuses.length > 0
        || this.selectedAdditionalStatuses.length > 0
        || this.selectedAssignees.length > 0
        || this.pageKind === LeadsPageKind.Leads && !HelperService.compareDateArrays(this.datePeriod, HelperService.getThisMonthPeriod())
        || this.pageKind === LeadsPageKind.Clients && !HelperService.compareDateArrays(this.clientsDatePeriod, HelperService.getThisMonthPeriod())
        || this.pageKind === LeadsPageKind.Leads && +this.selectedPriceType !== LeadPriceType.CampaignGlobalPrice
        || this.pageKind === LeadsPageKind.Clients && +this.clientsSelectedPriceType !== LeadPriceType.CampaignGlobalPrice;
  }

  get selectedAdditionalStatuses(): SelectListItem[] {
    if (!Array.isArray(this.additionalStatuses)) {
      return [];
    }
    return this.additionalStatuses.filter((i: SelectListItem) => this.usedSelectedAdditionalStatusesIds.indexOf(+i.Value) >= 0);
  }

  get selectedAdGroups(): MultiselectItem[] {
    if (!this.adGroups) {
      return [];
    }

    return this.adGroups.filter((i: MultiselectItem) => this.usedSelectedAdGroupsIds.indexOf(i.Id) >= 0);
  }

  get selectedAdTitlesFiltered(): AdTitlesByLeads[] {
    if (!this.adTitles) {
      return [];
    }

    return this.adTitles.filter((i: AdTitlesByLeads) => this.usedSelectedAdTitles.indexOf(this.getAdTitleId(i)) >= 0);
  }

  get selectedAssets(): ClientProject[] {
    if (!this.assets) {
      return [];
    }

    return this.assets.filter((i: ClientProject) => this.usedSelectedAssetsIds.indexOf(i.AssetId) >= 0);
  }

  get selectedAssignees(): Assignee[] {
    if (!this.assignees) {
      return [];
    }

    return this.assignees.filter((i: Assignee) => this.usedSelectedAssigneesIds.indexOf(i.SalesmanID) >= 0);
  }

  get selectedCallStatuses(): MultiselectItem[] {
    return LeadService.getCallStatuses().filter((i: MultiselectItem) => this.usedSelectedCallStatusesIds.indexOf(+i.Id) >= 0);
  }

  get selectedChannelMetadataTypes(): MultiselectItem[] {
    return CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Leads).filter((i: MultiselectItem) => this.usedSelectedChannelMetadataTypesIds.indexOf(+i.Id) >= 0);
  }

  get selectedChannels(): MultiselectItem[] {
    if (!this.channels) {
      return [];
    }

    return this.channels.filter((i: MultiselectItem) => this.usedSelectedChannelsIds.indexOf(i.Id as any as number) >= 0);
  }

  get selectedCompanies(): MultiselectItem[] {
    if (!this.companies) {
      return [];
    }

    return this.companies.filter((i: MultiselectItem) => this.usedSelectedCompaniesIds.indexOf(i.Id as any as number) >= 0);
  }

  get selectedCommitments(): MultiselectItem[] {
    if (!this.commitments) {
      return [];
    }

    return this.commitments.filter((i: MultiselectItem) => this.usedSelectedCommitmentsIds.indexOf(i.Id as any as number) >= 0);
  }

  get selectedFoundMetadataTypes(): MultiselectItem[] {
    return CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Leads).filter((i: MultiselectItem) => this.usedSelectedFoundMetadataTypesIds.indexOf(+i.Id) >= 0);
  }

  get selectedLeadStatuses(): MultiselectItem[] {
    return LeadService.getAvailableLeadStatuses().filter((i: MultiselectItem) => this.usedSelectedLeadStatusesIds.indexOf(i.Id as any as number) >= 0);
  }

  get selectedSaleStatuses(): MultiselectItem[] {
    return LeadService.getAvailableSaleStatuses().filter((i: MultiselectItem) => this.usedSelectedSaleStatusesIds.indexOf(+i.Id) >= 0);
  }

  get selectedTagsFiltered(): MultiselectItem[] {
    if (!this.tags) {
      return [];
    }

    return this.tags.filter((i: MultiselectItem) => this.usedSelectedTags.indexOf(i.Id) >= 0 || this.usedSelectedTags.indexOf(i.Title) >= 0);
  }


  //#region Getters based on page kind

  get usedSelectedAdditionalStatusesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAdditionalStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedAdditionalStatusesIds;
    }
  }

  get usedSelectedAdGroupsIds(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAdGroupsIds;
      case LeadsPageKind.Leads:
        return this.selectedAdGroupsIds;
    }
  }

  get usedSelectedAdTitles(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAdTitles;
      case LeadsPageKind.Leads:
        return this.selectedAdTitles;
    }
  }

  get usedSelectedAssetsIds(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAssetsIds;
      case LeadsPageKind.Leads:
        return this.selectedAssetsIds;
    }
  }

  get usedSelectedAssigneesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedAssigneesIds;
      case LeadsPageKind.Leads:
        return this.selectedAssigneesIds;
    }
  }

  get usedSelectedCallStatusesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedCallStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedCallStatusesIds;
    }
  }

  get usedSelectedChannelMetadataTypesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedChannelMetadataTypesIds;
      case LeadsPageKind.Leads:
        return this.selectedChannelMetadataTypesIds;
    }
  }

  get usedSelectedChannelsIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedChannelsIds;
      case LeadsPageKind.Leads:
        return this.selectedChannelsIds;
    }
  }

  get usedSelectedCompaniesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedCompaniesIds;
      case LeadsPageKind.Leads:
        return this.selectedCompaniesIds;
    }
  }

  get usedSelectedCommitmentsIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedCommitmentsIds;
      case LeadsPageKind.Leads:
        return this.selectedCommitmentsIds;
    }
  }

  get usedSelectedFoundMetadataTypesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedFoundMetadataTypesIds;
      case LeadsPageKind.Leads:
        return this.selectedFoundMetadataTypesIds;
    }
  }

  get usedSelectedLeadStatusesIds(): LeadStatus[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedLeadStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedLeadStatusesIds;
    }
  }

  get usedSelectedSaleStatusesIds(): LeadStatus[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedSaleStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedSaleStatusesIds;
    }
  }

  get usedSelectedTags(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedTags;
      case LeadsPageKind.Leads:
        return this.selectedTags;
    }
  }

  //#endregion Getters based on page kind


  //#region Setters based on page kind

  setUsedSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds);
        break;
    }
  }

  setUsedSelectedAdGroupsIds(sselectedAdGroupsIds: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAdGroupsIds(sselectedAdGroupsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdGroupsIds(sselectedAdGroupsIds);
        break;
    }
  }

  setUsedSelectedAdTitles(selectedAdTitles: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAdTitles(selectedAdTitles);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdTitles(selectedAdTitles);
        break;
    }
  }

  setUsedSelectedAssetsIds(selectedAssetsIds: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAssetsIds(selectedAssetsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAssetsIds(selectedAssetsIds);
        break;
    }
  }

  setUsedSelectedAssigneesIds(selectedAssigneesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAssigneesIds(selectedAssigneesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAssigneesIds(selectedAssigneesIds);
        break;
    }
  }

  setUsedSelectedCallStatusesIds(selectedCallStatusesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedCallStatusesIds(selectedCallStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedCallStatusesIds(selectedCallStatusesIds);
        break;
    }
  }

  setUsedSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds);
        break;
    }
  }

  setUsedSelectedChannelsIds(selectedChannelsIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedChannelsIds(selectedChannelsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedChannelsIds(selectedChannelsIds);
        break;
    }
  }

  setUsedSelectedCompaniesIds(selectedCompaniesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedCompaniesIds(selectedCompaniesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedCompaniesIds(selectedCompaniesIds);
        break;
    }
  }

  setUsedSelectedCommitmentsIds(selectedCommitmentsIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedCommitmentsIds(selectedCommitmentsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedCommitmentsIds(selectedCommitmentsIds);
        break;
    }
  }

  setUsedSelectedFoundMetadataTypesIds(selectedFoundMetadataTypesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedFoundMetadataTypesIds(selectedFoundMetadataTypesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedFoundMetadataTypesIds(selectedFoundMetadataTypesIds);
        break;
    }
  }

  setUsedSelectedLeadStatusesIds(selectedLeadStatusesIds: LeadStatus[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedLeadStatusesIds(selectedLeadStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedLeadStatusesIds(selectedLeadStatusesIds);
        break;
    }
  }

  setUsedSelectedSaleStatusesIds(selectedSaleStatusesIds: LeadStatus[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedSaleStatusesIds(selectedSaleStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedSaleStatusesIds(selectedSaleStatusesIds);
        break;
    }
  }

  setUsedSelectedTags(selectedTags: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedTags(selectedTags);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedTags(selectedTags);
        break;
    }
  }

  //#endregion Setters based on page kind


  onSelectedAdditionalStatusRemove(selectedAdditionalStatusesId: number): void {
    const selectedAdditionalStatusesIdsNew: number[] = this.usedSelectedAdditionalStatusesIds.filter((i) => i !== selectedAdditionalStatusesId);
    this.setUsedSelectedAdditionalStatusesIds(selectedAdditionalStatusesIdsNew);
  }

  onSelectedAdGroupRemove(selectedAdGroupsId: string): void {
    const selectedAdGroupsIdsNew: string[] = this.usedSelectedAdGroupsIds.filter((i) => i !== selectedAdGroupsId);
    this.setUsedSelectedAdGroupsIds(selectedAdGroupsIdsNew);
  }

  onSelectedAdTitleRemove(selectedAdTitle: string): void {
    const selectedAdTitlesNew: string[] = this.usedSelectedAdTitles.filter((i) => i !== selectedAdTitle);
    this.setUsedSelectedAdTitles(selectedAdTitlesNew);
  }

  onSelectedAssetRemove(selectedAssetsId: string): void {
    const selectedAssetsIdsNew: string[] = this.usedSelectedAssetsIds.filter((i) => i !== selectedAssetsId);
    this.setUsedSelectedAssetsIds(selectedAssetsIdsNew);
  }

  onSelectedAssigneeRemove(selectedAssigneesId: number): void {
    const selectedAssigneesIdsNew: number[] = this.usedSelectedAssigneesIds.filter((i) => i !== selectedAssigneesId);
    this.setUsedSelectedAssigneesIds(selectedAssigneesIdsNew);
  }

  onSelectedCallStatusRemove(selectedCallStatusesId: number): void {
    const selectedCallStatusesIdsNew: number[] = this.usedSelectedCallStatusesIds.filter((i) => i !== selectedCallStatusesId);
    this.setUsedSelectedCallStatusesIds(selectedCallStatusesIdsNew);
  }

  onSelectedChannelMetadataTypeRemove(selectedChannelMetadataTypeId: number): void {
    const selectedChannelMetadataTypesIdsNew: number[] = this.usedSelectedChannelMetadataTypesIds.filter((i) => i !== +selectedChannelMetadataTypeId);
    this.setUsedSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIdsNew);
  }

  onSelectedChannelRemove(selectedChannelsId: number): void {
    const selectedChannelsIdsNew: number[] = this.usedSelectedChannelsIds.filter((i) => i !== selectedChannelsId);
    this.setUsedSelectedChannelsIds(selectedChannelsIdsNew);
  }

  onSelectedCompanyRemove(selectedCompaniesId: number): void {
    const selectedCompaniesIdsNew: number[] = this.usedSelectedCompaniesIds.filter((i) => i !== selectedCompaniesId);
    this.setUsedSelectedCompaniesIds(selectedCompaniesIdsNew);
  }

  onSelectedCommitmentRemove(selectedCommitmentsId: number): void {
    const selectedCommitmentsIdsNew: number[] = this.usedSelectedCommitmentsIds.filter((i) => i !== selectedCommitmentsId);
    this.setUsedSelectedCommitmentsIds(selectedCommitmentsIdsNew);
  }

  onSelectedFoundMetadataTypeRemove(selectedFoundMetadataTypeId: number): void {
    const selectedFoundMetadataTypesIdsNew: number[] = this.usedSelectedFoundMetadataTypesIds.filter((i) => i !== +selectedFoundMetadataTypeId);
    this.setUsedSelectedFoundMetadataTypesIds(selectedFoundMetadataTypesIdsNew);
  }

  onSelectedLeadStatusRemove(selectedLeadStatusesId: string): void {
    const selectedLeadStatusesIdsNew: number[] = this.usedSelectedLeadStatusesIds.filter((i) => i.toString() !== selectedLeadStatusesId);
    this.setUsedSelectedLeadStatusesIds(selectedLeadStatusesIdsNew);
  }

  onSelectedSaleStatusRemove(selectedSaleStatusesId: LeadStatus): void {
    const selectedSaleStatusesIdsNew: LeadStatus[] = this.usedSelectedSaleStatusesIds.filter((i) => i !== selectedSaleStatusesId);
    this.setUsedSelectedSaleStatusesIds(selectedSaleStatusesIdsNew);
  }

  onSelectedTagRemove(selectedTag: string): void {
    const selectedTagsNew: string[] = this.usedSelectedTags.filter((i) => i !== selectedTag);
    this.setUsedSelectedTags(selectedTagsNew);
  }

  getAdTitleId(adTitle: AdTitlesByLeads): string {
    return HelperService.getAdTitleId(adTitle);
  }

  resetFilters(): void {
    LeadService.resetFilters(this.pageKind, this.leadsPageData.CompanyId !== 0);
  }

  stripTags(input: string): string {
    return input.replace(/(<([^>]+)>)/gi, " ");
  }
}
</script>
